import React, { useState } from "react";
import JobForm from "../JobForm/JobForm";
import { Card, CardContent, CardHeader, CardFooter } from "../Components/ui/card";
import { Heading, Text } from "../Components/ui/typography";
import { Badge } from "../Components/ui/badge";
import { Button } from "../Components/ui/button";
import { Dialog, DialogContent } from "../Components/ui/dialog";
import { Stack, Inline } from "../Components/ui/layout";
import { Separator } from "../Components/ui/separator";

const JobCard = ({ job }) => {
  const {
    jobId = job.id,
    title = job.jobTitle,
    company = job.companyName || "Company",
    location = job.jobLocation || "Location",
    experience = job.experience || "Experience",
    salary = `${job.minSalary} - ${job.maxSalary} ${job.salaryType}` || "Salary",
    type = job.jobType || "Job Type",
    tags = job.tags || "Tags",
    postedAgo = job.postedAgo || "N/A",
    logo = "https://via.placeholder.com/50",
  } = job;

  const tagsArray = tags.split(",").map((tag) => tag.trim());
  const [isJobFormOpen, setIsJobFormOpen] = useState(false);

  const handleApplyClick = () => setIsJobFormOpen(true);
  const handleCloseJobForm = () => setIsJobFormOpen(false);

  return (
    <>
      <Card className="hover:shadow-lg transition-shadow">
        <CardHeader>
          <Inline spacing="md" align="start">
            <img
              src={logo}
              alt={`${company} Logo`}
              className="w-12 h-12 rounded-full object-cover border border-border"
            />
            <Stack spacing="xs" className="flex-1">
              <Heading level="h3" className="text-xl md:text-2xl">
                {title}
              </Heading>
              <Text size="base" variant="muted">
                {company}
              </Text>
            </Stack>
          </Inline>
        </CardHeader>
        
        <CardContent>
          <Stack spacing="md">
            <Inline spacing="md" className="flex-wrap text-sm text-muted-foreground">
              <div className="flex items-center gap-2">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/96f5aece7e7ea8b30a06f09dd8521476a56ea82df95b306d0958370c4e54dd28"
                  alt="Location"
                  className="w-4 h-4"
                />
                {location}
              </div>
              <div className="flex items-center gap-2">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/a5bd1bb92a0fde6270356799045016e3f638e44dd611892fcd953957c9ef29f0"
                  alt="Experience"
                  className="w-4 h-4"
                />
                {experience}
              </div>
              <div className="flex items-center gap-2">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/3f25d9316ae12c689353bb86714bc2ac9fa9d6cc3e161e53bb6de559889e20eb"
                  alt="Salary"
                  className="w-4 h-4"
                />
                {salary}
              </div>
              <div className="flex items-center gap-2">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/180e506aad44daabc016aebb72c36bcbe0c0592cd3326b925933fd63c31c5067"
                  alt="Clock"
                  className="w-4 h-4"
                />
                {postedAgo}
              </div>
            </Inline>
            
            <Badge variant="secondary" className="w-fit">
              {type}
            </Badge>
            
            <Separator />
            
            <div className="flex flex-wrap gap-2">
              {tagsArray.map((tag, index) => (
                <Badge key={index} variant="outline" className="text-xs">
                  {tag}
                </Badge>
              ))}
            </div>
          </Stack>
        </CardContent>
        
        <CardFooter>
          <Inline spacing="sm" className="w-full">
            <Button variant="outline" className="flex-1">
              Am I a fit?
            </Button>
            <Button variant="default" onClick={handleApplyClick} className="flex-1">
              Apply Now
            </Button>
          </Inline>
        </CardFooter>
      </Card>

      <Dialog open={isJobFormOpen} onOpenChange={setIsJobFormOpen}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
          <JobForm jobId={jobId} onClose={handleCloseJobForm} />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default JobCard;
